export default objects => {
	objects.forEach(obj => obj.style.display = "none");
	return objects;
}
